import moment from 'moment-timezone'

import {ManualKpi, ManualKpiDto} from '../types'

/**
 * Maps ManualKpiDto array to ManualKpi array with timezone-aware dates
 */
export const mapManualKpis = (manualKpis: ManualKpiDto[], timezone: string): ManualKpi[] =>
  manualKpis.map((manualKpi: ManualKpiDto) => ({
    ...manualKpi,
    createdAt: moment.utc(manualKpi.createdAt).tz(timezone),
    updatedAt: moment.utc(manualKpi.updatedAt).tz(timezone),
    timestamp: moment.utc(manualKpi.timestamp).tz(timezone)
  }))
